import * as React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
export const CustomDialog = props => {
  return <Dialog {...props} title='Irrigation Task' />;
};